import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';

import { ReimbursementsService } from './reimbursements.service';
import { Observable } from 'rxjs';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { map, switchMap } from 'rxjs/operators';
import { Reimbursement } from '@bciti/types';

@Injectable({ providedIn: 'root' })
export class ReimbursementsServiceImpl implements ReimbursementsService {
    constructor(private store: Store<State>, private http: HttpClient) {}

    postReimbursement(reimbursement: Reimbursement): Observable<boolean> {
        return this.store.select(environmentSelector).pipe(switchMap((env) => this.http.post(`${env.baseUrl}/payments/admin/credit`, reimbursement).pipe(map((res) => res as boolean))));
    }
}

export const REIMBURSEMENTS_SERVICE_IMPL = {
    provide: ReimbursementsService,
    useClass: ReimbursementsServiceImpl,
};
